import styles from "./instagram-skin-1.module.css";
import { UiButton } from "@ui-monorepo/index";
import { FC } from "react";
import {
  InstagramData,
  useAnalytics,
  WidgetProps,
  InstagramConfig } from
"@commons-monorepo/index";
import { useTranslation } from "react-i18next";
import WidgetContainer from "../../../widget-container";

const InstagramSkin1: FC<WidgetProps<InstagramData[], InstagramConfig>> = ({
  id,
  data,
  config,
  theme,
  storeMetadata
}) => {
  const INSTAGRAM_URL = `https://www.instagram.com/${config?.username}`;
  const [logEvent] = useAnalytics({ storeMetadata });
  const { t } = useTranslation();
  const log = (option: string) => {
    logEvent("select_button", {
      event_subtype: "instagram_posts",
      user_type: "buyer",
      platform: "web",
      option
    });
  };
  const highLightBackground = config?.highlight_background;

  return (
    <WidgetContainer
      id={id}
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highLightBackground}>

      <div className={styles.instagramSkin1Container}>
        <a
          href={INSTAGRAM_URL}
          target={"_blank"}
          onClick={() => {
            log("text_link");
          }}
          rel='noreferrer'>

          <h3 className={styles.instagramTitle}>
            {t("instagram.follow_in")} @
            {config?.username ? config?.username : "instagram.store"}
          </h3>
        </a>
        <div className={styles.instagramPhotos}>
          <a
            href={data && data[0]?.postUrl}
            target={"_blank"}
            className={styles.mainImage}
            onClick={() => {
              log("post");
            }}
            rel='noreferrer'>

            {data && data[0]?.isVideo &&
            <figure className={`${styles.reelIcon} icon-play`} />}

            <figure
              className={`${styles.instagramIcon} icon-instagram-circle-outline`} />

            <img src={data && data[0]?.displayUrl} alt='Imagen principal' />
          </a>
          {data?.slice(1).map((item, index) =>
          <a
            href={item.postUrl}
            target={"_blank"}
            className={styles.secondaryImage}
            key={index}
            onClick={() => {
              log("post");
            }}
            rel='noreferrer'>

              {item.isVideo &&
            <figure className={`${styles.reelIcon} icon-play`} />}

              <figure
              className={`${styles.instagramIcon} icon-instagram-circle-outline`} />

              <img
              src={item.displayUrl}
              alt={`Imagen secundaria ${index + 1}`} />

            </a>
          )}
        </div>
      </div>
    </WidgetContainer>);

};

export default InstagramSkin1;